import React, { Component } from 'react'
import { auth, database, ref, get, onValue, off } from './firebase.js'
import GroupsContext from './GroupsContext.jsx'

const withGroups = (Comp) => {
  class WithGroups extends Component {
    constructor (props) {
      super(props)
      this.state = {
        groups: [],
        empty: null
      }
      this.userId = auth.currentUser.uid
      this.dbRef = ref(database, `usuarios/grupos/${this.userId}`)
      this.groups = []
    }
    componentDidMount () {
      // Listen for changes in user's groups
      this.unsubscribe = onValue(this.dbRef, (snapshot) => {
        if (!snapshot.exists()) {
          this.setState({
            groups: [],
            empty: true
          })
          return
        }

        const groupPromises = []
        snapshot.forEach((childSnap) => {
          groupPromises.push(this.getData(childSnap.key))
        })

        Promise.all(groupPromises)
          .then((groups) => {
            groups.sort((a, b) => {
              if (a.created < b.created) return 1
              if (a.created > b.created) return -1
              return 0
            })
            this.setState({ groups })
          })
          .catch((err) => {
            console.error(err)
          })
      })
    }
    componentWillUnmount () {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      off(this.dbRef)
    }
    getData (id) {
      return new Promise((resolve, reject) => {
        let admin, titulo, cover, created, mode
        const groupRef = ref(database, `grupos/index/${id}`)
        get(groupRef)
          .then((snap) => {
            if (!snap.exists()) {
              reject(new Error('Group not found'))
              return
            }
            admin = snap.val().admin
            titulo = snap.val().titulo
            cover = snap.val().cover
            created = snap.val().created
            mode = snap.val().mode
            const modeRef = ref(database, `quinielas/modalidades/${mode}`)
            return get(modeRef)
          })
          .then((snap) => {
            resolve({
              id: id,
              admin: admin,
              titulo: titulo,
              cover: cover,
              created: created,
              mode: snap.val().titulo,
              active: snap.val().active
            })
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
    render () {
      if (this.state.empty || this.state.groups.length > 0) {
        return (
          <GroupsContext.Provider value={this.state.groups}>
            <Comp />
          </GroupsContext.Provider>
        )
      } else {
        return null
      }
    }
  }
  return WithGroups
}

export default withGroups
